"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SABRE_GET_MANUFACTURERS = void 0;
var client_1 = require("@apollo/client");
var fragments_1 = require("../fragments");
exports.SABRE_GET_MANUFACTURERS = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query GetManufacturers($input: ManufacturersInput) {\n    manufacturers(input: $input) {\n      count\n      hasMore\n      results {\n        ...Manufacturer\n      }\n    }\n  }\n  ", "\n"], ["\n  query GetManufacturers($input: ManufacturersInput) {\n    manufacturers(input: $input) {\n      count\n      hasMore\n      results {\n        ...Manufacturer\n      }\n    }\n  }\n  ", "\n"])), fragments_1.SABRE_MANUFACTURER_FRAGMENT);
var templateObject_1;
